import axios from 'axios'
import { getApiGatewayUrl, getApiTimeout } from '../config.js'

const axiosInstance = axios.create({
    baseURL: getApiGatewayUrl() || import.meta.env.VITE_API_URL,
    timeout: getApiTimeout(),
    headers: {
        'Content-Type': 'application/json'
    }
})

// Add request interceptor to add auth headers
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token')
        const sessionId = localStorage.getItem('sessionId')
        if (token) {
            config.headers['X-Auth-Token'] = token
        }
        if (sessionId) {
            config.headers['SessionID'] = sessionId
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

export default axiosInstance
